import Maybe from 'graphql/tsutils/Maybe';
import { EventsQuery, WeddingWebsiteQuery, QuestionsFragment } from '../generated/graphql';

interface QuestionsInfo {
  rsvpQuestionCount: number;
  rsvpQuestionCategories: string[];
  rsvpQuestionTypes: string[];
}

const answerTypeToAnalyticType: { [char: string]: string } = {
  Option: 'choice',
  Text: 'open',
};

export default (eventData: Maybe<EventsQuery>, wwsData: Maybe<WeddingWebsiteQuery>): QuestionsInfo => {
  const rsvpQuestionCount = (() => {
    const eventQuestionsCount =
      eventData?.events?.reduce((a, b) => {
        a += b.questions?.length || 0;
        return a;
      }, 0) || 0;
    const generalQuestionsCount = wwsData?.guestWedding?.questions?.length ?? 0;
    return eventQuestionsCount + generalQuestionsCount;
  })();

  const rsvpQuestionCategories = () => {
    const eventQuestionTypes =
      eventData?.events?.reduce((a, b) => {
        return a.concat(b.questions?.map(q => q.type || '') || []);
      }, [] as string[]) ?? [];
    const generalQuestionTypes = wwsData?.guestWedding?.questions?.map(q => q.type) ?? [];
    const merged = [...eventQuestionTypes, ...generalQuestionTypes];
    const mergedUnique = merged.filter((v, i) => merged.indexOf(v) === i) as string[];
    return mergedUnique || [];
  };

  const rsvpQuestionTypes = () => {
    const eventQuestions = eventData?.events?.reduce((a, b) => {
      return a.concat(b.questions || []);
    }, [] as QuestionsFragment[]);

    const eventAnswerTypes =
      eventQuestions?.map(q => (q.answerType ? `event ${answerTypeToAnalyticType[q.answerType]}` : '')) || [];
    const generalAnswerTypes =
      wwsData?.guestWedding?.questions?.map(q =>
        q.answerType ? `general ${answerTypeToAnalyticType[q.answerType]}` : ''
      ) || [];

    const merged = [...eventAnswerTypes, ...generalAnswerTypes];
    const mergedUnique = merged.filter((v, i) => merged.indexOf(v) === i);
    return mergedUnique;
  };

  return {
    rsvpQuestionCount,
    rsvpQuestionCategories: rsvpQuestionCategories(),
    rsvpQuestionTypes: rsvpQuestionTypes(),
  };
};
